<template>
  <div>
    <div id="goz_esnetme">
      <h3 style="font-size: 27px; text-align: center">
        <strong>60 saniye</strong> içerisinde size verilen okuma metnini
        okuduktan sonra anlama testinde en az
        <strong>%50 başarılı</strong> olmanız beklenmektedir.
      </h3>
      <el-button type="primary" class="mt-5">HAZIRSANIZ BAŞLAYALIM</el-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import moment from "moment";
export default {
  name: "SpeedTest",
  props: ["config"],
  data() {
    return {
      pause: false,
      content: null,
    };
  },
  created() {},
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 458px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  background-size: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/modules/SpeedTest.vue